export const ru = {
  // Common
  common: {
    loading: 'Загрузка...',
    error: 'Ошибка',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    create: 'Создать',
    add: 'Добавить',
    update: 'Обновить',
    search: 'Поиск',
    clear: 'Очистить',
    close: 'Закрыть',
    confirm: 'Подтвердить',
    yes: 'Да',
    no: 'Нет',
    actions: 'Действия',
    status: 'Статус',
    date: 'Дата',
    name: 'Название',
    description: 'Описание',
    amount: 'Сумма',
    price: 'Цена',
    total: 'Итого',
    showing: 'Показано',
    of: 'из',
    noData: 'Данные не найдены',
    all: 'Все',
    dismiss: 'Закрыть',
    created: 'Создано',
    updated: 'Обновлено',
    deleting: 'Удаление...',
    saving: 'Сохранение...',
    saveChanges: 'Сохранить изменения',
    deleted: 'Удалён',
    areYouSure: 'Вы уверены?',
  },

  // Navigation
  nav: {
    dashboard: 'Панель управления',
    companyExpenses: 'Расходы компании',
    personalExpenses: 'Личные расходы',
    workers: 'Работники',
    customers: 'Клиенты',
    orders: 'Заказы',
    products: 'Продукция',
    sell: 'Продажи',
    materials: 'Материалы',
    materialIncomes: 'Поступление материалов',
    pricing: 'Ценообразование',
    profile: 'Профиль',
    admin: 'Админ',
  },

  // User menu
  userMenu: {
    upgradeToPro: 'Перейти на Pro',
    account: 'Аккаунт',
    billing: 'Оплата',
    notifications: 'Уведомления',
    logout: 'Выйти',
  },

  // Login
  login: {
    title: 'Войдите в аккаунт',
    subtitle: 'Введите email для входа в аккаунт',
    email: 'Электронная почта',
    password: 'Пароль',
    forgotPassword: 'Забыли пароль?',
    loginButton: 'Войти',
    loggingIn: 'Вход...',
    emailPlaceholder: 'm@example.com',
  },

  // Dashboard
  dashboard: {
    title: 'Панель управления',
    activeWorkers: 'Активные работники',
    pending: 'ожидает',
    inactive: 'неактивных',
    newOrders: 'Новые заказы',
    inProgress: 'в работе',
    completed: 'выполнено',
    totalCustomerDebt: 'Общий долг клиентов',
    totalGiven: 'Всего выдано',
    productsThisWeek: 'Продукция за неделю',
    period: 'Период',
    workerRanking: 'Рейтинг работников',
    byTotalProducts: 'По количеству продукции',
    orders: 'заказы',
    products: 'продукция',
    noWorkerData: 'Нет данных о работниках',
    topDebtors: 'Топ должников',
    totalAmount: 'Общая сумма',
    noDebtorsFound: 'Должники не найдены',
    materialsStock: 'Склад материалов',
    currentInventory: 'Текущий уровень запасов',
    noMaterialsInStock: 'Нет материалов на складе',
    ordersOverview: 'Обзор заказов',
    currentOrderStatus: 'Статистика статусов заказов',
    new: 'Новые',
    cancelled: 'Отменено',
    monthlyExpenses: 'Ежемесячные расходы',
    expenseSummary: 'Сводка расходов по месяцам',
    noExpenseData: 'Нет данных о расходах',
    budgetOverview: 'Обзор бюджета',
    companyFinances: 'Финансы компании',
    income: 'Доход',
    inventoryValue: 'Стоимость запасов',
    totalCompanyValue: 'Общая стоимость компании',
    materialsValue: 'Стоимость материалов',
    productsValue: 'Стоимость продукции',
  },

  // Workers
  workers: {
    title: 'Работники',
    totalWorkers: 'Всего работников',
    totalProfit: 'Общая прибыль',
    totalPaid: 'Всего выплачено',
    priceReferences: 'Справочник цен',
    noPriceReferences: 'Справочник цен не найден.',
    square: 'Клетка',
    manageWorkers: 'Управление и просмотр информации о работниках',
    searchPlaceholder: 'Поиск по имени или email...',
    allStatus: 'Все статусы',
    accepted: 'Принят',
    pending: 'Ожидает',
    rejected: 'Отклонён',
    inactive: 'Неактивен',
    worker: 'Работник',
    received: 'Получено',
    balance: 'Баланс',
    joined: 'Присоединился',
    noWorkersFound: 'Работники не найдены.',
    noWorkersMatch: 'Нет работников, соответствующих фильтрам.',
    showingWorkers: 'Показано {{count}} из {{total}} работников',
    pendingApproval: 'Ожидает одобрения',
    priceRefDetails: 'Детали справочника цен',
    updateOrDelete: 'Обновить или удалить этот справочник цен',
    enterSquare: 'Введите значение клетки',
    enterPrice: 'Введите цену',
    updating: 'Обновление...',
    updatePriceRef: 'Обновить справочник цен',
    deletePriceRef: 'Удалить справочник цен',
    deleting: 'Удаление...',
    areYouSure: 'Вы уверены?',
    deleteConfirmation: 'Это действие нельзя отменить. Справочник цен для клетки "{{square}}" будет полностью удалён.',
    amountOwed: 'Сумма к выплате работнику',
    workerOwes: 'Работник должен эту сумму',
    createPriceRef: 'Создать справочник цен',
    createPriceRefDesc: 'Добавить новый справочник цен',
    // Worker Detail page
    backToWorkers: 'Вернуться к работникам',
    pendingApprovalRequired: 'Требуется одобрение',
    pendingApprovalDesc: 'Этот работник ожидает одобрения. Пожалуйста, проверьте его информацию и одобрите или отклоните его аккаунт.',
    approveWorker: 'Одобрить работника',
    reject: 'Отклонить',
    receivedAmount: 'Полученная сумма',
    statusManagement: 'Управление статусом',
    workerStatus: 'Статус работника',
    changeStatusHint: 'Измените статус работника для управления его доступом и видимостью.',
    timestamps: 'Временные метки',
    lastUpdated: 'Последнее обновление',
    workerNotFound: 'Работник не найден',
    productsDescription: 'Вся продукция, изготовленная этим работником',
    noProducts: 'Продукция не найдена',
    issueSalary: 'Выдать зарплату',
    issueSalaryDesc: 'Выдать зарплату работнику',
    amount: 'Сумма',
  },

  // Customers
  customers: {
    title: 'Клиенты',
    totalCustomers: 'Всего клиентов',
    totalGiven: 'Всего выдано',
    totalOwed: 'Общий долг',
    manageCustomers: 'Управление и просмотр информации о клиентах',
    addCustomer: 'Добавить клиента',
    createCustomer: 'Создать клиента',
    createCustomerDesc: 'Создать новую запись клиента',
    fullName: 'Полное имя',
    enterFullName: 'Введите полное имя',
    phoneNumber: 'Номер телефона',
    searchPlaceholder: 'Поиск по имени или телефону...',
    given: 'Выдано',
    owed: 'Долг',
    noCustomersFound: 'Клиенты не найдены.',
    noCustomersMatch: 'Нет клиентов, соответствующих фильтрам.',
    showingCustomers: 'Показано {{count}} из {{total}} клиентов',
    creating: 'Создание...',
    // Customer Detail page
    backToCustomers: 'Вернуться к клиентам',
    totalPaidByCustomer: 'Общая сумма, оплаченная клиентом',
    amountOwed: 'Сумма долга',
    remainingBalance: 'Остаток к оплате',
    totalOrders: 'Всего заказов',
    ordersPlaced: 'Количество размещённых заказов',
    contactInfo: 'Контактная информация',
    timestamps: 'Временные метки',
    created: 'Создано',
    lastUpdated: 'Последнее обновление',
    customerNotFound: 'Клиент не найден',
    customerNotFoundDesc: 'Клиент, которого вы ищете, не существует или был удалён.',
    editCustomer: 'Редактировать клиента',
    updateCustomerInfo: 'Обновить информацию о клиенте',
    deleteCustomer: 'Удалить клиента',
    deleteCustomerConfirmation: 'Вы уверены, что хотите удалить клиента "{{name}}"? Это действие нельзя отменить.',
    ordersDescription: 'Все заказы, размещённые этим клиентом',
    noOrders: 'Заказы не найдены',
    addIncome: 'Добавить платёж',
    addIncomeDesc: 'Зарегистрировать новый платёж от клиента',
    addDebt: 'Добавить долг',
    addDebtDesc: 'Зарегистрировать новый долг клиента',
    invalidDebtAmount: 'Сумма не может быть нулевой или отрицательной',
    amount: 'Сумма',
    boughtProducts: 'Купленная продукция',
    boughtProductsDescription: 'Вся продукция, купленная этим клиентом',
    noBoughtProducts: 'Продукция не найдена',
  },

  // Orders
  orders: {
    title: 'Заказы',
    totalOrders: 'Всего заказов',
    totalRevenue: 'Общий доход',
    totalPaid: 'Всего оплачено',
    pendingOrders: 'Ожидающие заказы',
    manageOrders: 'Просмотр и управление всеми заказами',
    searchPlaceholder: 'Поиск по клиенту, телефону или материалу...',
    allStatuses: 'Все статусы',
    new: 'Новый',
    inProgress: 'В работе',
    completed: 'Выполнен',
    cancelled: 'Отменён',
    client: 'Клиент',
    dimensions: 'Размеры',
    paid: 'Оплачено',
    noOrdersFound: 'Заказы не найдены.',
    noOrdersMatch: 'Нет заказов, соответствующих фильтрам.',
    showingOrders: 'Показано {{count}} из {{total}} заказов',
    filterByStatus: 'Фильтр по статусу',
    orderNumber: 'Заказ #{{id}}',
    editOrder: 'Редактировать заказ',
    updateOrderInfo: 'Обновить информацию о заказе',
    amountDue: 'К оплате',
    fullyPaid: 'Полностью оплачено',
    createOrder: 'Создать заказ',
    dimensionsHint: 'Формат: сим квадрат высота ширина количество (например: 2 40 1.5 10 40)',
    selectClient: 'Выберите клиента',
    enterClientName: 'Введите имя клиента',
    color: 'Цвет',
    selectColor: 'Выберите цвет',
    wireType: 'Тип проволоки',
    selectWireType: 'Выберите тип проволоки',
    sellingType: 'Тип продажи',
    selectSellingType: 'Выберите тип продажи',
    profit: 'Прибыль',
    prePayment: 'Предоплата',
    optional: 'Необязательно',
    changeType: 'Тип изменения',
    discount: 'Скидка',
    markup: 'Наценка',
    setDeadline: 'Установить срок',
    deadline: 'Срок',
    // Order Detail page
    backToOrders: 'Вернуться к заказам',
    fullPrice: 'Полная стоимость',
    leftPrice: 'Остаток оплаты',
    unitPrice: 'Цена за единицу',
    remaining: 'Остаток',
    progress: 'Прогресс',
    itemsCompleted: 'Выполнено единиц',
    clientInformation: 'Информация о клиенте',
    fullName: 'Полное имя',
    phoneNumber: 'Номер телефона',
    materialDetails: 'Детали материала',
    material: 'Материал',
    thickness: 'толщина',
    dimensionsAndQuantity: 'Размеры и количество',
    width: 'Ширина',
    height: 'Высота',
    square: 'Клетка',
    quantity: 'Количество',
    weightInformation: 'Информация о весе',
    currentWeight: 'Текущий вес',
    requiredWeight: 'Требуемый вес',
    createdBy: 'Создал',
    name: 'Имя',
    email: 'Email',
    role: 'Роль',
    timestamps: 'Временные метки',
    created: 'Создано',
    lastUpdated: 'Последнее обновление',
    assignedWorkers: 'Назначенные работники',
    orderNotFound: 'Заказ не найден',
    orderNotFoundDesc: 'Заказ, который вы ищете, не существует или был удалён.',
    deleteConfirmTitle: 'Вы уверены?',
    deleteConfirmDesc: 'Это действие нельзя отменить. Заказ #{{id}} будет полностью удалён.',
    doneQuantity: 'Выполнено',
    selectStatus: 'Выберите статус',
    status: 'Статус',
    createdAt: 'Создано',
    price: 'Цена',
  },

  // Products
  products: {
    title: 'Доходы от продукции',
    type: 'Тип',
    quantity: 'Количество',
    productTypes: 'Типы продукции',
    totalCount: 'Общее количество',
    totalWeight: 'Общий вес',
    productQuantities: 'Количество продукции',
    viewInventory: 'Просмотр инвентаря продукции по материалам и размерам',
    searchPlaceholder: 'Поиск по материалу, размерам...',
    allMaterials: 'Все материалы',
    material: 'Материал',
    square: 'Клетка',
    height: 'Высота (м)',
    width: 'Ширина (м)',
    count: 'Количество',
    weight: 'Вес',
    noProductsFound: 'Продукция не найдена.',
    noProductsMatch: 'Нет продукции, соответствующей фильтрам.',
    showingProducts: 'Показано {{count}} из {{total}} типов продукции',
    inventory: 'Склад',
    inventoryDescription: 'Агрегированное количество продукции по материалам и размерам',
    thickness: 'Толщина',
    color: 'Цвет',
    cell: 'ячейка',
    allThicknesses: 'Все толщины',
    dimensions: 'Размеры',
    workerPrice: 'Цена работника',
    createdAt: 'Создано',
    fullWeight: 'Общий вес',
    mustWeight: 'Треб. вес',
  },

  // Materials
  materials: {
    title: 'Материалы',
    totalMaterials: 'Всего материалов',
    totalWeight: 'Общий вес',
    materialTypes: 'Типы материалов',
    materialsTab: 'Материалы',
    colorsTab: 'Цвета',
    wireTypesTab: 'Типы проволоки',
    manageInventory: 'Управление и просмотр инвентаря материалов',
    searchPlaceholder: 'Поиск по названию, цвету или типу...',
    allColors: 'Все цвета',
    allTypes: 'Все типы',
    type: 'Тип',
    color: 'Цвет',
    thickness: 'Толщина',
    noMaterialsFound: 'Материалы не найдены.',
    noMaterialsMatch: 'Нет материалов, соответствующих фильтрам.',
    showingMaterials: 'Показано {{count}} из {{total}} материалов',
    colors: 'Цвета',
    viewColors: 'Просмотр доступных цветов материалов',
    addColor: 'Добавить цвет',
    addNewColor: 'Добавить новый цвет',
    createColor: 'Создать новый цвет материала',
    colorName: 'Название цвета',
    colorPlaceholder: 'например, Красный, Синий',
    noColorsFound: 'Цвета не найдены.',
    totalColors: 'Всего: {{count}} цветов',
    wireTypes: 'Типы проволоки',
    viewWireTypes: 'Просмотр доступных типов проволоки',
    addWireType: 'Добавить тип проволоки',
    addNewWireType: 'Добавить новый тип проволоки',
    createWireType: 'Создать новый тип проволоки',
    wireTypeName: 'Название типа проволоки',
    wireTypePlaceholder: 'например, Медь, Алюминий',
    noWireTypesFound: 'Типы проволоки не найдены.',
    totalWireTypes: 'Всего: {{count}} типов проволоки',
    id: 'ID',
    deleteColor: 'Удалить цвет',
    deleteColorConfirm: 'Вы уверены, что хотите удалить цвет "{{name}}"?. Это действие нельзя отменить.',
    deleteWireType: 'Удалить тип проволоки',
    deleteWireTypeConfirm: 'Вы уверены, что хотите удалить тип проволоки "{{name}}"?. Это действие нельзя отменить.',
  },

  // Material Incomes
  materialIncomes: {
    title: 'Поступление материалов',
    totalIncomes: 'Всего поступлений',
    totalWeight: 'Общий вес',
    totalCost: 'Общая стоимость',
    totalLeftPrice: 'Итого остаток',
    manageIncomes: 'Управление и просмотр поступлений материалов',
    addIncome: 'Добавить поступление',
    createIncome: 'Создать поступление материала',
    createIncomeDesc: 'Создать новую запись поступления материала',
    selectMaterial: 'Выберите материал',
    quantity: 'Количество (кг)',
    enterQuantity: 'Введите количество',
    pricePerKg: 'Цена за кг',
    enterPrice: 'Введите цену',
    enterGivenMoney: 'Введите внесённую сумму',
    searchPlaceholder: 'Поиск по материалу, цвету, типу или поставщику...',
    materialName: 'Название материала',
    kg: 'Кг',
    perKg: 'За кг',
    noIncomesFound: 'Поступления материалов не найдены.',
    noIncomesMatch: 'Нет поступлений, соответствующих фильтрам.',
    showingIncomes: 'Показано {{count}} из {{total}} поступлений',
    creating: 'Создание...',
    // Form fields
    wireName: 'Название проволоки',
    enterWireName: 'Введите название проволоки',
    color: 'Цвет',
    selectColor: 'Выберите цвет',
    wireType: 'Тип проволоки',
    selectWireType: 'Выберите тип проволоки',
    thickness: 'Толщина (мм)',
    supplier: 'Поставщик',
    enterSupplier: 'Введите поставщика',
    arrivalDate: 'Дата поступления',
    // Table headers
    material: 'Материал',
    type: 'Тип',
    weight: 'Вес',
    priceKg: 'Цена/кг',
    fullPrice: 'Полная стоимость',
    leftPrice: 'Остаток оплаты',
    givenMoney: 'Внесено',
    arrived: 'Поступил',
    actions: 'Действия',
    // Add given money
    addGivenMoney: 'Добавить внесённую сумму',
    addGivenMoneyDesc: 'Добавить внесённую сумму для материала {{material}}',
    amount: 'Сумма',
    invalidGivenMoneyAmount: 'Сумма должна быть положительным числом',
    // Filters
    allColors: 'Все цвета',
    allTypes: 'Все типы',
    // Delete dialog
    deleteTitle: 'Удалить поступление материала',
    deleteDescription: 'Вы уверены, что хотите удалить эту запись поступления материала для',
    deleteWarning: 'Это действие нельзя отменить.',
  },

  // Pricing
  pricing: {
    title: 'Ценообразование',
    addSellType: 'Добавить тип продажи',
    createSellingType: 'Создать тип продажи',
    addWirePrice: 'Добавить цену проволоки',
    createWirePrice: 'Создать цену проволоки',
    wireName: 'Название (Сим)',
    wireSquare: 'Клетка',
    wireThickness: 'Толщина (мм)',
    wireWeight: 'Вес (Кг)',
    wirePrice: 'Цена',
    showingCombinations: '{{wires}} цен проволоки × {{types}} типов продажи = {{total}} возможных комбинаций ({{configured}} настроено)',
    doubleClickToEdit: 'Дважды щёлкните для редактирования',
    doubleClickToAdd: 'Дважды щёлкните для добавления',
    katak: 'Катак',
    sim: 'Сим',
    formula: 'Формула',
    kg: 'Кг',
    narx135: 'Общая Цена',
    narx: 'Нарх',
    foyda: 'Прибыль',
    delete: 'Удалить',
    budgetCalcPrices: 'Цены расчёта бюджета',
    product: 'Товар',
    material: 'Материал',
  },

  // Expenses
  expenses: {
    title: 'Расходы',
    companyExpenses: 'Расходы компании',
    personalExpenses: 'Личные расходы',
    totalExpenses: 'Общие расходы',
    totalIncome: 'Общий доход',
    balance: 'Баланс',
    addExpense: 'Добавить расход',
    addNewExpense: 'Добавить новый расход',
    createExpense: 'Создать расход',
    createNewExpense: 'Создать новый доход или расход',
    createPersonalExpense: 'Добавить личный расход',
    createPersonalExpenseDesc: 'Создать новый личный доход или расход',
    manageExpenses: 'Управление доходами и расходами компании',
    managePersonalExpenses: 'Управление личными доходами и расходами',
    category: 'Категория',
    selectCategory: 'Выберите категорию',
    enterDescription: 'Введите описание...',
    enterAmount: 'Введите сумму',
    searchPlaceholder: 'Поиск по описанию, админу, сумме...',
    allCategories: 'Все категории',
    allTypes: 'Все типы',
    noExpensesFound: 'Расходы не найдены. Нажмите "Добавить расход".',
    noExpensesFoundPersonal: 'Личные расходы не найдены. Нажмите "Добавить расход".',
    noExpensesMatch: 'Нет расходов, соответствующих фильтрам.',
    showingExpenses: 'Показано {{count}} из {{total}} расходов',
    selectWorker: 'Выберите работника',
    loadingWorkers: 'Загрузка работников...',
    selectOrder: 'Выберите заказ',
    loadingOrders: 'Загрузка заказов...',
    revenueType: 'Тип дохода',
    selectType: 'Выберите тип',
    income: 'Доход',
    expense: 'Расход',
    expenseType: 'Тип расхода',
    company: 'Компания',
    salary: 'Зарплата',
    order: 'Заказ',
    worker: 'Работник',
    material: 'Материал',
    type: 'Тип',
    admin: 'Админ',
    descriptionOptional: 'Описание (необязательно)',
    other: 'Другое',
    backToExpenses: 'Вернуться к расходам',
    backToPersonalExpenses: 'Вернуться к личным расходам',
    expenseNumber: 'Расход #{{id}}',
    personalExpenseNumber: 'Личный расход #{{id}}',
    noDescription: 'Описание не указано',
    deleteExpense: 'Удалить расход',
    deletePersonalExpense: 'Удалить личный расход',
    deleteConfirmation: 'Вы уверены, что хотите удалить этот расход? Это действие нельзя отменить.',
    deletePersonalConfirmation: 'Вы уверены, что хотите удалить этот личный расход? Это действие нельзя отменить.',
    relatedInfo: 'Связанная информация',
    createdBy: 'Создал',
    timestamps: 'Временные метки',
    created: 'Создано',
    lastUpdated: 'Последнее обновление',
    expenseNotFound: 'Расход не найден',
    amount: 'Сумма',
    description: 'Описание',
    date: 'Дата',
  },

  // Profile
  profile: {
    title: 'Профиль',
    personalInfo: 'Личная информация',
    manageInfo: 'Управление вашей личной информацией',
    firstName: 'Имя',
    lastName: 'Фамилия',
    email: 'Электронная почта',
    phone: 'Телефон',
    avatar: 'Аватар',
    changeAvatar: 'Изменить аватар',
    editProfile: 'Редактировать',
    cancel: 'Отмена',
    saveChanges: 'Сохранить изменения',
    saving: 'Сохранение...',
    selectLanguage: 'Выберите предпочитаемый язык интерфейса',
    emailCannotChange: 'Email нельзя изменить',
    accountCreated: 'Аккаунт создан',
    lastUpdated: 'Последнее обновление',
    updateSuccess: 'Профиль успешно обновлён',
    unableToLoad: 'Не удалось загрузить профиль',
    joined: 'Присоединился',
  },

  // Detail pages
  detail: {
    back: 'Назад',
    orderDetails: 'Детали заказа',
    workerDetails: 'Детали работника',
    customerDetails: 'Детали клиента',
    expenseDetails: 'Детали расхода',
    transactions: 'Транзакции',
    noTransactions: 'Транзакции не найдены',
    addTransaction: 'Добавить транзакцию',
    addPayment: 'Добавить платёж',
    paymentAmount: 'Сумма платежа',
    notes: 'Заметки',
    createdAt: 'Дата создания',
    updatedAt: 'Дата обновления',
  },

  // Unauthorized
  unauthorized: {
    title: 'Доступ запрещён',
    message: 'У вас нет прав для доступа к этой странице.',
    goBack: 'Вернуться назад',
    goToLogin: 'Перейти на страницу входа',
  },

  // Statuses
  status: {
    active: 'Активный',
    inactive: 'Неактивный',
    pending: 'Ожидает',
    accepted: 'Принят',
    rejected: 'Отклонён',
    new: 'Новый',
    in_progress: 'В работе',
    completed: 'Выполнен',
    cancelled: 'Отменён',
    pendingApproval: 'Ожидает одобрения',
  },

  // Errors
  errors: {
    failedToLoad: 'Ошибка загрузки данных',
    failedToCreate: 'Ошибка создания',
    failedToUpdate: 'Ошибка обновления',
    failedToDelete: 'Ошибка удаления',
    failedToLoadWorkers: 'Ошибка загрузки работников',
    failedToLoadCustomers: 'Ошибка загрузки клиентов',
    failedToLoadOrders: 'Ошибка загрузки заказов',
    failedToLoadProducts: 'Ошибка загрузки продукции',
    failedToLoadMaterials: 'Ошибка загрузки материалов',
    failedToLoadPrices: 'Ошибка загрузки цен',
    failedToUpdatePriceRef: 'Ошибка обновления справочника цен',
    failedToDeletePriceRef: 'Ошибка удаления справочника цен',
    unauthorized: 'Доступ запрещён',
    networkError: 'Ошибка сети',
  },

  // Language
  language: {
    title: 'Язык',
    uz: 'Узбекский',
    ru: 'Русский',
  },

  // Available Products (public)
  availableProducts: {
    title: 'Доступная продукция',
    description: 'Просмотр доступной продукции на складе',
    productTypes: 'Типы продукции',
    totalCount: 'Общее количество',
    totalWeight: 'Общий вес',
    inventoryTitle: 'Каталог продукции',
    inventoryDescription: 'Доступная продукция с размерами и наличием',
    searchPlaceholder: 'Поиск по размерам...',
    thickness: 'Тол-на',
    cell: 'Ячейка',
    height: 'Высота',
    width: 'Ши-на',
    count: 'Кол-во',
    weight: 'Вес',
    allCells: 'Все ячейки',
    noProductsFound: 'Продукция не найдена.',
    noProductsMatch: 'Нет продукции, соответствующей фильтрам.',
    contactInfo: 'Для заказа свяжитесь с нами',
    request: 'Заказать',
    requestTitle: 'Оформить заявку',
    requestDescription: 'Заполните форму для отправки заявки на продукцию',
    productInfo: 'Информация о продукции',
    available: 'В наличии',
    quantity: 'Количество',
    quantityPlaceholder: 'Введите количество',
    phoneNumber: 'Номер телефона',
    sendRequest: 'Отправить заявку',
    requestSuccess: 'Заявка отправлена!',
    requestSuccessMessage: 'Мы свяжемся с вами в ближайшее время для подтверждения заказа.',
    invalidQuantity: 'Пожалуйста, введите корректное количество',
    quantityExceedsStock: 'Количество превышает доступный остаток',
    requestFailed: 'Не удалось отправить заявку. Попробуйте ещё раз.',
    // Custom product request
    customRequest: 'Заказать продукцию',
    customRequestTitle: 'Заказать продукцию по размерам',
    customRequestDescription: 'Заполните форму, чтобы заказать продукцию с нужными вам размерами',
    customRequestButton: 'Оформить заказ',
    enterThickness: 'Введите толщину',
    enterCell: 'Введите ячейку',
    enterHeight: 'Введите высоту',
    enterWidth: 'Введите ширину',
    enterQuantity: 'Введите количество',
    allFieldsRequired: 'Пожалуйста, заполните все поля',
    invalidValues: 'Все значения должны быть положительными числами',
  },

  // Sell
  sell: {
    title: 'Продажи',
    addSale: 'Добавить продажу',
    totalSales: 'Всего продаж',
    totalRevenue: 'Общая выручка',
    totalProfit: 'Общая прибыль',
    salesHistory: 'История продаж',
    salesDescription: 'Просмотр и управление записями о продажах',
    searchPlaceholder: 'Поиск по материалу, продавцу...',
    material: 'Материал',
    cell: 'Ячейка',
    height: 'Высота',
    width: 'Ширина',
    quantity: 'Количество',
    price: 'Цена',
    profit: 'Прибыль',
    createdBy: 'Продавец',
    date: 'Дата',
    noSalesFound: 'Продажи не найдены.',
    noSalesMatch: 'Нет продаж, соответствующих фильтрам.',
    createSale: 'Создать продажу',
    createDescription: 'Выберите товар и укажите количество для создания продажи',
    selectProduct: 'Выберите товар',
    selectProductPlaceholder: 'Выберите товар из списка',
    noProductsAvailable: 'Нет доступных товаров',
    selectedProduct: 'Выбранный товар',
    available: 'Доступно',
    quantityPlaceholder: 'Введите количество',
    invalidQuantity: 'Количество должно быть положительным числом.',
    invalidProfit: 'Прибыль должна быть числом.',
    loadProductsFailed: 'Не удалось загрузить товары.',
    createFailed: 'Не удалось создать продажу. Попробуйте ещё раз.',
    // Stock errors
    insufficientStockWeight: 'Недостаточный вес на складе для указанного товара.',
    insufficientStockQuantity: 'Недостаточное количество на складе для указанного товара.',
    productNotInSellingType: 'Выбранный товар не существует в выбранном типе продажи.',
    // Price preview
    pricePreview: 'Предпросмотр цены',
    kg: 'Вес',
    inputData: 'Введённые данные',
    customerGivenPrice: 'Оплата клиента',
    // Delete
    deleteConfirmation: 'Вы уверены, что хотите удалить продажу "{{material}}" (ячейка {{cell}})? Это действие нельзя отменить.',
  },
}
